
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/msa",
      function () {
        return require("private-next-pages/legal/msa/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/msa"])
      });
    }
  